import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/mergeMap';
import type { Location, RouterActionPush } from '@atlassian/react-resource-router';

import {
	type CardsBulkOperationsDeleteRequestsAction,
	CARDS_BULK_OPERATIONS_DELETE_REQUESTS,
} from '../../state/actions/cards/bulk-operations-delete/index.tsx';
import type { ActionsObservable } from '../../state/types.tsx';
import { removeSelectedIssueFromUrl } from '../../services/routing/selected-issue-url-change/index.tsx';

export const cardsBulkOperationsDeleteRequestEpic =
	(getLocation: () => Location, push: RouterActionPush) => (action$: ActionsObservable) =>
		action$
			.ofType(CARDS_BULK_OPERATIONS_DELETE_REQUESTS)
			.flatMap((action: CardsBulkOperationsDeleteRequestsAction) => {
				if (action.payload.length === 0) {
					return Observable.empty<never>();
				}

				push(removeSelectedIssueFromUrl(getLocation()));

				return Observable.empty<never>();
			});
